import React, { Component } from 'react';
import _ from 'lodash';
import storageCategories from '../storage-space-categories.json';

class StorageCalculator extends Component {
  constructor(props) {
    super(props);
    const element = document.getElementById('storage-calculator');
    const listingsUrl = element.getAttribute('data-listings-url');
    // Initialize with amounts set to 0 if not already defined
    const initialCategories = _.cloneDeep(storageCategories);
    initialCategories.forEach(category => {
      category.storageItems.forEach(item => {
        item.amount = item.amount || 0;
      });
    });
    
    this.state = {
      categories: initialCategories,
      listingsUrl: listingsUrl
    };
  }

  // Find the category and item indexes to update them
  incrementItem = (categoryIndex, itemIndex) => {
    const updatedCategories = _.cloneDeep(this.state.categories);
    const item = updatedCategories[categoryIndex].storageItems[itemIndex];
    
    if (item.amount < 99) {
      item.amount++;
      this.setState({ categories: updatedCategories });
    }
  }

  decrementItem = (categoryIndex, itemIndex) => {
    const updatedCategories = _.cloneDeep(this.state.categories);
    const item = updatedCategories[categoryIndex].storageItems[itemIndex];
    
    if (item.amount > 0) {
      item.amount--;
      this.setState({ categories: updatedCategories });
    }
  }

  handleItemChange = (categoryIndex, itemIndex, event) => {
    const value = event.target.value;
    if (value === '' || (value >= 0 && value <= 99)) {
      const updatedCategories = _.cloneDeep(this.state.categories);
      updatedCategories[categoryIndex].storageItems[itemIndex].amount = value === '' ? 0 : parseInt(value, 10);
      this.setState({ categories: updatedCategories });
    }
  }

  calculateCategoryArea = (category) => {
    let squareArea = 0;
    let cubicArea = _.sum(_.map(category.storageItems, item => (item.amount || 0) * item.cubic)).toFixed(2);
    if (!isNaN(cubicArea)) {
      squareArea = (cubicArea * 1.1 / 3).toFixed(1);
    }
    return squareArea;
  }

  clearItems = (categoryIndex) => {
    const updatedCategories = _.cloneDeep(this.state.categories);
    updatedCategories[categoryIndex].storageItems.forEach(item => {
      item.amount = 0;
    });
    this.setState({ categories: updatedCategories });
  }

  isNumeric = (e) => {
    const allowedKeys = [8]; // backspace
    const keyCode = e.which ? e.which : e.keyCode;
    const isNumericKey = (keyCode >= 48 && keyCode <= 57) || allowedKeys.indexOf(keyCode) !== -1;
    
    if (!isNumericKey) {
      e.preventDefault();
    }
    return isNumericKey;
  }

  calculateTotalArea = () => {
    let squareArea = 0;
    let cubicArea = _.sum(_.map(this.state.categories, category => {
      return _.sum(_.map(category.storageItems, item => (item.amount || 0) * item.cubic));
    }));
    
    if (!isNaN(cubicArea)) {
      squareArea = (cubicArea * 1.1 / 3).toFixed(1);
    }
    return squareArea;
  }

  getNextLargestSize = (calculatedArea) => {
    // Standard available sizes
    const availableSizes = [5, 10, 15, 20, 30, 50];
    const area = parseFloat(calculatedArea);
    
    console.log('getNextLargestSize called with calculatedArea:', calculatedArea, 'parsed as:', area);
    
    // Find the largest size that is still <= calculatedArea (next lowest)
    let selectedSize = availableSizes[0]; // Default to smallest (5)
    
    for (let i = 0; i < availableSizes.length; i++) {
      if (availableSizes[i] <= area) {
        selectedSize = availableSizes[i];
      } else {
        break; // Stop when we find one that's larger
      }
    }
    
    console.log('Returning next lowest size:', selectedSize);
    return selectedSize;
  }

  render() {
    const totalArea = this.calculateTotalArea();
    const nextLargestSize = this.getNextLargestSize(totalArea);

    return (
      <div className="row calculator-container xs-mt-20">
        {/* storage categories */}
        <div className="col-sm-3">
          <div className="panel panel-default">
            <ul className="nav nav-stacked" role="tablist">
              {this.state.categories.map((category, index) => (
                <li 
                  className={index === 0 ? 'active' : ''} 
                  role="presentation" 
                  key={index}
                >
                  <a 
                    href={`#category${index}`} 
                    aria-controls={`category${index}`} 
                    role="tab" 
                    data-toggle="tab"
                  >
                    {category.name}&nbsp;
                    {this.calculateCategoryArea(category) > 0 && (
                      <span className="badge">
                        {this.calculateCategoryArea(category)} m<sup>2</sup>
                      </span>
                    )}
                  </a>
                </li>
              ))}
            </ul>
            {totalArea > 0 && (
              <div className="alert alert-info">
                Total area: {totalArea} m<sup>2</sup>
              </div>
            )}
          </div>
          {totalArea > 0 && (
            <div className="col-sm-12 text-center xs-mt-10 xs-mb-30">
              <a 
                href={`${this.state.listingsUrl}?min_area=${nextLargestSize}`} 
                className="btn btn-primary"
              >
                Find this unit size
              </a>
            </div>
          )}
        </div>
        
        {/* storage items */}
        <div className="col-sm-9">
          <div className="tab-content">
            {this.state.categories.map((category, categoryIndex) => (
              <div 
                id={`category${categoryIndex}`} 
                role="tabpanel" 
                className={`tab-pane ${categoryIndex === 0 ? 'active in' : ''}`}
                key={categoryIndex}
              >
                <div className="panel panel-default clearfix">
                  <div className="panel-heading clearfix">
                    <h4 className="pull-left">
                      {category.name}
                    </h4>
                    {this.calculateCategoryArea(category) > 0 && (
                      <div className="pull-right">
                        <button 
                          className="btn btn-danger" 
                          onClick={() => this.clearItems(categoryIndex)}
                        >
                          Clear selection
                        </button>
                      </div>
                    )}
                  </div>

                  <div className="panel-body">
                    {category.storageItems.map((item, itemIndex) => (
                      <div className="item col-sm-6 clearfix xs-mb-15" key={itemIndex}>
                        <div className="pull-left">
                          <img src={item.imageUrl} alt={item.name} />
                          <span className="xs-ml-10">{item.name}</span>
                        </div>

                        <div className="pull-right" style={{ width: '108px' }}>
                          <div className="input-group">
                            <a 
                              href="#" 
                              className="input-group-addon btn-primary" 
                              onClick={(e) => {
                                e.preventDefault();
                                this.decrementItem(categoryIndex, itemIndex);
                              }}
                            >
                              -
                            </a>
                            <input 
                              type="text" 
                              maxLength="2" 
                              value={item.amount || 0} 
                              onChange={(e) => this.handleItemChange(categoryIndex, itemIndex, e)}
                              onKeyPress={this.isNumeric}
                              className="form-control" 
                              style={{ maxHeight: '40px' }}
                            />
                            <a 
                              href="#" 
                              className="input-group-addon btn-primary" 
                              onClick={(e) => {
                                e.preventDefault();
                                this.incrementItem(categoryIndex, itemIndex);
                              }}
                            >
                              +
                            </a>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <style dangerouslySetInnerHTML={{
          __html: `
            input[type="number"] {
              -webkit-appearance: none;
            }
          `
        }} />
      </div>
    );
  }
}

export default StorageCalculator;